import { SettingsApiService } from 'Services/ApiServices';
import { normalizeApiResponse } from 'Helpers/ApiHelpers';
import { GET_F2W_SETTINGS_SUCCESS } from 'Constants/SettingConstants';
import F2WCustomLogger from 'Services/F2WCustomLogger';

export function getF2wSettings() {
  function getF2wSettingsSuccess(settings) {
    return {
      type: GET_F2W_SETTINGS_SUCCESS,
      data: { settings },
    };
  }

  return async function (dispatch) {
    try {
      const response = await SettingsApiService.getMaintenance();
      const { data } = normalizeApiResponse(response);
      dispatch(getF2wSettingsSuccess(data || {}));
    } catch (error) {
      F2WCustomLogger.error('Error fetching settings', error, { action: 'getF2wSettings' });
      dispatch(getF2wSettingsSuccess({}));
    }
  };
}
